import React, {Component} from "react";
import LoaderModal from "./LoaderModal";
import ShareItemModal from "./ShareItemModal";
import EmbedProcedureModal from "./EmbedProcedureModal";
import CreateRenameModal from "./CreateRenameModal";
import './modal.scss';
import DeleteUserModal from "./DeleteUserModal";
import ChangeEmailModal from "./ChangeEmailModal";
import CropperDialog from "./CropperDialog";
import ProcedurePreviewModal from "./ProcedurePreviewModal";
import AlertSnackbar from "./AlertSnackbar";
import UploadMediaDialog from "./UploadMediaDialog";
import MediaLibraryModal from "./MediaLibraryModal";
import DeleteRoleModal from "./DeleteRoleModal";
import RichTextCkeEditorDialog from "./RichTextCkeEditorDialog";
import PublishVersionModal from "./PublishVersionModal";
import ReleaseNotesDialog from "./ReleaseNotesDialog";
import CreateMediaProcedureDialog from "./CreateMediaProcedureDialog";
import EditMediaProcedureDialog from "./EditMediaProcedureDialog";
import ProgressLoaderModal from "./ProgressLoaderModal";
import DeleteMediaItemsModal from "./DeleteMediaItemsModal";
import UnPublishProcedureModal from "./UnPublishProcedureModal";
import ProcedurePublishedModal from "./ProcedurePublishedModal";
import {SessionPlayerModal} from "./SessionPlayerModal";
import TooManyConnectionsDialog from "./TooManyConnectionsDialog";
import KickedOutDialog from "./KickedOutDialog";
import {GenerateQRModal} from "./GenerateQRModal";
import SelectFusionDialog from "./SelectFusionDialog";
import DomainExpiredDialog from "./DomainExpiredDialog";
import SwitchDomainDialog from "./SwitchDomainDialog";
import TooManyUsersDialog from "./TooManyUsersDialog";
import DeleteNotificationsModal from "./DeleteNotificationsModal";
import FrontlineArDialog from "./FrontlineArDialog";
import {CreatChecklistDialog} from "./CreatChecklistDialog";
import ProcedureStatsModal from "./ProcedureStatsModal";
import ProcedureSettingsModal from "./ProcedureSettings/ProcedureSettingsModal";
import FolderSettingsModal from "./FolderSettings/FolderSettingsModal";
import ProjectSettingsModal from "./ProjectSettings/ProjectSettingsModal";
import {DomainBlockedDialog} from "./DomainBlockedModal";
import Edit3dAvatarModal from "./Edit3dAvatarModal";
import DeleteModeModal from "./DeleteModeModal";
import DayadaPasswordDialog from "./DayadaPasswordDialog";
import DayadaFilePreviewDialog from "./DayadaFilePreviewDialog";
import ActionSnackbar from "./ActionSnackbar";
import CreateEditLinkItemModal from "./CreateLinkItemModal";
import RemindToPublishModal from "./RemindToPublishModal";
import PayPerClickSharingModal from "./PayPerClickSharingModal";
import CancelPayPerClickModal from "./CancelPayPerClickModal";
import PayPerClickAnalyticsModal from "./PayPerClickAnalyticsModal";
import EditorLanguageModal from "./EditorLanguageModal";
import ConfirmChangeDefaultLanguage from "./ConfirmChangeDefaultLanguage";
import DeleteNodeDialog from "./DeleteNodeDialog";
import HideHelpButtonModal from "./HideHelpButtonModal";
import InteractionsEditorModal from "./InteractionsEditorModal";
import DeleteInteractionModal from "./DeleteInteractionModal";
import DuplicateItemsModal from "./DuplicateItemsModal";
import DeleteItemsModal from "./DeleteItemsModal";
import GeneralConfirmActionDialog from "./GeneralConfirmActionDialog";
import AutoGenerateReportsModal from "./AutoGenerateReportsModal";
import RequireUserDetailsModal from "./RequireUserDetailsModal";
import SetSitePrepNameModal from "./SetSitePrepNameModal";
import SelectSitePrepFusionFilesModal from "./SelectSitePrepFusionFilesModal";
import EditSitePrepChecklistModal from "./EditSitePrepChecklistModal";
import SelectSitePrepTemplateModal from "./SelectSitePrepTemplateModal";
import AddSitePrepUsersModal from "./AddSitePrepUsersModal";
import SelectDigitalTwinUploadModal from "./SelectDigitalTwinUpload/SelectDigitalTwinUploadModal";
import SetInteractionFolderNameModal from "./SetInteractionFolderNameModal";
import SetInteractionNameModal from "./SetInteractionNameModal";
import FindProcedureAttachmentModal from "./FindProcedureAttachmentModal";
import ReplaceMediaModal from "./ReplaceMediaModal";
import UploadProcedureGuideDialog from "./uploadProcedureGuideDialogFolder/UploadProcedureGuideDialog";
import {GenericSelectSearchModal} from "../Generic/GenericSelectSearchModal"
import {useStores} from "../../Hooks"
import CreateEditWorkspaceModal from "./SubWorkspacesManagmentModals/CreateEditWorkspaceModal";
import {GenerateReportsModal} from "./SubWorkspacesManagmentModals/GenerateReportsModal/GenerateReportsModal";
import {ConditionalChatComponent} from "./AiChat/ConditionalChatComponent";
import UploadGuideToastModal from "./uploadProcedureGuideDialogFolder/UploadGuideToastModal";
import ProgressLoaderModalWithMassage from "./ProgressLoderModalWithMessage";
import {ChooseRolePopup} from "./ChooseRolePopup/ChooseRolePopup";
import {FilePreviewModal} from "./FilesPreviewModal";
import {TestAiChatModal} from "./AiChat/TestAiChat";
import InteractionUsagesModal from "./InteractionUsagesModal";
import SurveyPopUp from "./SurveyModal/SurveyPopup";
import SurveyModal from "./SurveyModal/SurveyModal";
import RecordingWarningModal from "./RecordingWarningModal";
import AccessModal from "./AccessModal/AccessModal";
import InviteMembersModal from "./InviteMembers/InviteMembersModal";
import IncomingCallToast from "./IncomingCallToast";

class ModalsContainer extends Component {
    render() {
        return (
            <React.Fragment>
                <RecordingWarningModal/>
                <CreateRenameModal/>
                <ShareItemModal/>
                <GenerateQRModal/>
                <EmbedProcedureModal/>
                <LoaderModal/>
                <DeleteUserModal/>
                <ChangeEmailModal/>
                <CropperDialog/>
                <ChooseRolePopup/>
                <FilePreviewModal/>
                <ProcedurePreviewModal/>
                <AlertSnackbar/>
                <ActionSnackbar/>
                <ConditionalChatComponent/>
                <UploadMediaDialog/>
                <UploadProcedureGuideDialog/>
                <UploadGuideToastModal/>
                <MediaLibraryModal/>
                <DeleteRoleModal/>
                <DeleteModeModal/>
                <RichTextCkeEditorDialog/>
                <PublishVersionModal/>
                <ReleaseNotesDialog/>
                <CreateMediaProcedureDialog/>
                <EditMediaProcedureDialog/>
                <ProgressLoaderModal/>
                <ProgressLoaderModalWithMassage/>
                <DeleteMediaItemsModal/>
                <ReplaceMediaModal/>
                <UnPublishProcedureModal/>
                <ProcedurePublishedModal/>
                < SessionPlayerModal/>
                <TooManyConnectionsDialog/>
                <KickedOutDialog/>
                <SelectFusionDialog/>
                <DomainExpiredDialog/>
                <DomainBlockedDialog/>
                <SwitchDomainDialog/>
                <TooManyUsersDialog/>
                <DeleteNotificationsModal/>
                <FrontlineArDialog/>
                <CreatChecklistDialog/>
                <ProcedureStatsModal/>
                <ProcedureSettingsModal/>
                <FolderSettingsModal/>
                <ProjectSettingsModal/>
                <Edit3dAvatarModal/>
                <DayadaPasswordDialog/>
                <DayadaFilePreviewDialog/>
                <CreateEditLinkItemModal/>
                <RemindToPublishModal/>
                <PayPerClickSharingModal/>
                <CancelPayPerClickModal/>
                <PayPerClickAnalyticsModal/>
                {/*<ConfirmAddSdkToUserModal/>*/}
                <EditorLanguageModal/>
                <ConfirmChangeDefaultLanguage/>
                <DeleteNodeDialog/>
                <HideHelpButtonModal/>
                <InteractionsEditorModal/>
                <DeleteInteractionModal/>
                <DuplicateItemsModal/>
                <DeleteItemsModal/>
                <GeneralConfirmActionDialog/>
                <AutoGenerateReportsModal/>
                <RequireUserDetailsModal/>
                <SetSitePrepNameModal/>
                <SelectSitePrepFusionFilesModal/>
                <EditSitePrepChecklistModal/>
                <SelectSitePrepTemplateModal/>
                <AddSitePrepUsersModal/>
                <CreateEditWorkspaceModal/>
                <GenerateReportsModal/>
                <SelectDigitalTwinUploadModal/>
                <SetInteractionFolderNameModal/>
                <SetInteractionNameModal/>
                <InteractionUsagesModal/>
                <FindProcedureAttachmentModal/>
                <TestAiChatModal/>
                <SurveyPopUp/>
                <SurveyModal/>
                <AccessModal/>
                <InviteMembersModal/>
                <IncomingCallToast/>
                <GenericSelectSearchModal useStores={useStores}/>
            </React.Fragment>
        )
    }
}

export default ModalsContainer;
